import { getAiDubbingTaskResult } from '~/composables/api/aiDubbing.js'

export const AI_DUBBING_POLL_INTERVAL_MS = 5000
export const AI_DUBBING_POLL_MAX_ATTEMPTS = 120

export function resolveAiDubbingResultUrl(data) {
  const result = data?.result
  if (Array.isArray(result) && result[0]) return String(result[0]).trim()
  if (typeof result === 'string' && result.trim()) return result.trim()
  return ''
}

export function isAiDubbingSuccess(data) {
  return Number(data?.status) === 1
}

export function isAiDubbingFailed(data) {
  return Number(data?.status) === 2
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** @param {string} taskId */
export async function pollAiDubbingResult(taskId, options = {}) {
  const id = String(taskId || '').trim()
  if (!id) throw new Error('ai_dubbing_missing_task_id')

  const interval = options.intervalMs ?? AI_DUBBING_POLL_INTERVAL_MS
  const maxAttempts = options.maxAttempts ?? AI_DUBBING_POLL_MAX_ATTEMPTS

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const res = await getAiDubbingTaskResult({ task_id: id })
    if (res.code !== 100000) {
      throw new Error(res.message || 'ai_dubbing_poll_failed')
    }

    const data = res.data
    if (isAiDubbingSuccess(data)) return data
    if (isAiDubbingFailed(data)) {
      throw new Error(data?.message || 'ai_dubbing_task_failed')
    }
    if (attempt < maxAttempts - 1) {
      await sleep(interval)
    }
  }

  throw new Error('ai_dubbing_timeout')
}
